import { IconPropsType } from '..';

export const UsersFillIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.99968 27.4647C1.39267 27.1135 0.886523 26.6073 0.535314 26.0003L0.968093 25.7499C0.67049 25.2356 0.5 24.6384 0.5 24V21.7778H0V19.5556H0.5V15.1111H0V12.8889H0.5V8.44444H0V6.22222H0.5V4C0.5 3.36155 0.67049 2.76444 0.968093 2.25008L0.535313 1.99968C0.886523 1.39267 1.39267 0.886523 1.99968 0.535313L2.25008 0.968093C2.76444 0.67049 3.36155 0.5 4 0.5H6.22222V0H8.44444V0.5H12.8889V0H15.1111V0.5H19.5556V0H21.7778V0.5H24C24.6384 0.5 25.2356 0.67049 25.7499 0.968093L26.0003 0.535314C26.6073 0.886523 27.1135 1.39267 27.4647 1.99968L27.0319 2.25008C27.3295 2.76444 27.5 3.36155 27.5 4V6.22222H28V8.44444H27.5V12.8889H28V15.1111H27.5V19.5556H28V21.7778H27.5V24C27.5 24.6384 27.3295 25.2356 27.0319 25.7499L27.4647 26.0003C27.1135 26.6073 26.6073 27.1135 26.0003 27.4647L25.7499 27.0319C25.2356 27.3295 24.6384 27.5 24 27.5H21.7778V28H19.5556V27.5H15.1111V28H12.8889V27.5H8.44444V28H6.22222V27.5H4C3.36155 27.5 2.76444 27.3295 2.25008 27.0319L1.99968 27.4647Z"
      stroke="#02ABCC"
      strokeDasharray="4 2"
    />
    <g clipPath="url(#clip0_3427_8403)">
      <path
        d="M14.0008 6.80078C10.0239 6.80078 6.80078 10.0239 6.80078 14.0008C6.80078 17.9777 10.0239 21.2008 14.0008 21.2008C17.9777 21.2008 21.2008 17.9777 21.2008 14.0008C21.2008 10.0239 17.9777 6.80078 14.0008 6.80078ZM14.0008 10.4008C15.1193 10.4008 16.0258 11.3075 16.0258 12.4258C16.0258 13.544 15.1202 14.4508 14.0008 14.4508C12.8825 14.4508 11.9758 13.544 11.9758 12.4258C11.9758 11.3075 12.8814 10.4008 14.0008 10.4008ZM14.0008 19.4008C12.5121 19.4008 11.163 18.7952 10.1842 17.8176C10.6398 16.6417 11.7648 15.8008 13.1008 15.8008H14.9008C16.2378 15.8008 17.3628 16.6412 17.8173 17.8176C16.8386 18.7961 15.4886 19.4008 14.0008 19.4008Z"
        fill="#017F99"
      />
    </g>
    <defs>
      <clipPath id="clip0_3427_8403">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(6 6)"
        />
      </clipPath>
    </defs>
  </svg>
);
